<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="color"
        :label="label"
        v-bind="attrs"
        v-on="on"
        :color="color"
      >
        <template v-slot:prepend-inner>
          <v-icon :color="color">palette</v-icon>
        </template>
        <template v-slot:append>
          <v-btn icon small @click="$emit('reset')">
            <v-icon>restart_alt</v-icon>
          </v-btn>
        </template>
      </v-text-field>
    </template>
    <v-color-picker 
      :value="color" 
      show-swatches 
      hide-sliders 
      mode="hexa" 
      @update:color="color => $emit('input', color.hex)"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'ColorSelector',
  props: {
    value: {type: String, required: true},
    label: {type: String, required: false, default: ''}
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    color: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>